<template>
    <div ref="preview" class="branding-preview">
        <div class="browser">
            <div class="browser__tab">
                <!-- eslint-disable-next-line vuejs-accessibility/alt-text -->
                <img class="browser__favicon" :src="faviconPreview.src" />
                <p>Browser Tab</p>
            </div>
            <div class="browser__bar">
                <div class="browser__bar__icon"></div>
                <div class="browser__bar__icon"></div>
                <div class="browser__bar__icon"></div>
                <div class="browser__bar__url"></div>
                <div class="browser__bar__icon right"></div>
                <div class="browser__bar__icon right"></div>
            </div>
            <div class="browser__main website">
                <!-- Browser Content: start --->
                <header class="website__header">
                    <div class="website__logo" :style="`background-image: url(${logoPreview.src})`"></div>
                    <div class="website__nav">
                        <div class="website__nav__item">
                            <div class="website__nav__icon"></div>
                            <p>Menu item</p>
                        </div>
                        <div class="website__nav__item">
                            <div class="website__nav__icon"></div>
                            <p>Menu item</p>
                        </div>
                        <div class="website__nav__item">
                            <div class="website__nav__icon"></div>
                            <p>Menu item</p>
                        </div>
                    </div>
                    <div class="website__account">
                        <div>
                            <p>Username</p>
                            <p>Account</p>
                        </div>
                        <div
                            class="website__account__avatar"
                            :style="`background-image: url(${avatarPreview.src})`"
                        ></div>
                    </div>
                </header>
                <main class="website__page">
                    <header class="website__page__header">
                        <div class="tabs">
                            <div class="tabs__tab"><p>Tab 1</p></div>
                            <div class="tabs__tab active"><p>Tab 2</p></div>
                            <div class="tabs__tab"><p>Tab 3</p></div>
                            <div class="tabs__tab"><p>Tab 4</p></div>
                            <div class="tabs__tab"><p>Tab 5</p></div>
                            <div class="tabs__tab"><p>Tab 6</p></div>
                            <div class="tabs__tab"><p>Tab 7</p></div>
                        </div>
                        <div class="website__page__header__actions">
                            <button class="button">Button</button>
                            <label class="switch">
                                <input type="checkbox" />
                                <div class="switch__toggle"></div>
                                <p>Switch</p>
                            </label>
                        </div>
                    </header>

                    <div class="overline">Page Overline</div>
                    <div class="heading">Page Heading</div>

                    <table>
                        <thead>
                            <tr>
                                <th>Column 1</th>
                                <th>Column 2</th>
                                <th>Column 3</th>
                                <th>Column 4</th>
                                <th>Column 5</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                        </tbody>
                    </table>
                </main>
                <!-- Browser Content: end --->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingsBrandingPreview',
    props: {
        logoPreview: {
            type: Object,
            default: null
        },
        avatarPreview: {
            type: Object,
            default: null
        },
        faviconPreview: {
            type: Object,
            default: null
        },
        primaryBackground: {
            type: String,
            default: 'primaryBackground'
        },
        primaryLight: {
            type: String,
            default: 'primaryLight'
        },
        primaryText: {
            type: String,
            default: 'primaryText'
        }
    }
};
</script>

<style lang="scss" scoped>
.branding-preview {
    position: relative;
    // background: repeating-conic-gradient(#eee 0% 25%, #ddd 0% 50%) 50% / 2rem 2rem;
    perspective: 100vw;
}

.browser {
    transform: rotateY(-24deg) scale(0.9) translateX(-7%);
    box-shadow:
        0 4px 4px rgba(0, 0, 0, 0.11),
        0 8px 8px rgba(0, 0, 0, 0.11),
        0 16px 16px rgba(0, 0, 0, 0.11),
        0 32px 32px rgba(0, 0, 0, 0.11),
        0 32px 64px rgba(0, 0, 0, 0.11);
    position: relative;
    background: #fff;
    border-radius: 0 4px 4px 4px;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(0, 0, 0, 0.07);
    &__tab {
        position: absolute;
        left: -1px;
        bottom: 100%;
        background: #fff;
        height: 1.8rem;
        width: 10rem;
        border-radius: 4px 4px 0 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: default;
        border-top: 1px solid rgba(0, 0, 0, 0.07);
        border-left: 1px solid rgba(0, 0, 0, 0.07);
        border-right: 1px solid rgba(0, 0, 0, 0.07);
        p {
            font-size: 0.77rem;
            margin: 0.1rem 0 0 0.2rem;
            color: rgba(0, 0, 0, 0.6);
        }
    }
    &__favicon {
        display: block;
        height: 1.2rem;
        width: 1.2rem;
        margin-left: 0.4rem;
    }
    &__bar {
        display: flex;
        padding: 0.4rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        background: #fff;
        border-radius: 0 4px 0 0;
        &__icon {
            width: 1.4rem;
            height: 1.4rem;
            background: rgba(0, 0, 0, 0.05);
            border-radius: 100%;
            margin-right: 0.4rem;
            flex-shrink: 0;
            &.right {
                margin-right: 0;
                margin-left: 0.4rem;
            }
        }
        &__url {
            width: 100%;
            height: 1.4rem;
            background: rgba(0, 0, 0, 0.05);
            border-radius: 2px;
            white-space: nowrap;
            overflow: hidden;
            &:before {
                content: 'https://browser-website-address.url';
                line-height: 1.5rem;
                color: rgba(0, 0, 0, 0.5);
                margin-left: 0.4rem;
                font-size: 0.8rem;
            }
        }
    }
    &__main {
        flex-grow: 1;
        background: #f5f5f5;
        position: relative;
    }
}

.website {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 0 0 4px 4px;

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 4rem;
        background: #fff;
        border-bottom: 1px solid #eee;
    }

    &__logo {
        width: 10%;
        height: 80%;
        margin-left: 0.5rem;
        min-width: 8rem;
        border-radius: 4px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
    }

    &__nav {
        width: 10%;
        height: 100%;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        min-width: 12rem;
        flex-grow: 1;
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        border-left: 1px solid #f5f5f5;
        overflow: hidden;
        &__item {
            min-width: 5rem;
            border-right: 1px solid #f5f5f5;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.4rem;
            cursor: default;
            transition: background 0.15s ease-in-out;
            &:hover {
                background: rgba(0, 0, 0, 0.04);
            }
        }
        &__icon {
            height: 1.4rem;
            width: 1.4rem;
            border-radius: 100%;
            background: var(--preview-primaryBackground);
        }
        p {
            text-align: center;
            font-size: 0.7rem;
            margin: 0.4rem 0 0 0;
            color: var(--preview-primaryText);
        }
    }

    &__account {
        width: 10%;
        margin-right: 0.5rem;
        min-width: 8rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0.2rem;
        border-radius: 4px;
        cursor: default;
        transition: background 0.15s ease-in-out;
        &:hover {
            background: rgba(0, 0, 0, 0.04);
        }
        p {
            margin: 0;
            font-size: 0.8rem;
            text-align: right;
            color: var(--preview-primaryText);
            &:last-of-type {
                font-size: 0.7rem;
            }
        }
        &__avatar {
            height: 2.2rem;
            width: 2.2rem;
            border-radius: 100%;
            overflow: hidden;
            margin: 0.2rem 0.2rem 0.2rem 0.4rem;
            background-position: center center;
            background-size: contain;
            background-repeat: no-repeat;
        }
    }

    &__page {
        flex-grow: 1;
        padding: 1rem;
        background: #fff;
        &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 1rem;
            &__actions {
                margin-left: 1rem;
                display: flex;
            }
        }
    }
}

.tabs {
    background: var(--preview-primaryLight);
    height: 2.4rem;
    border-radius: 4px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    &__tab {
        height: 100%;
        padding: 0 1rem;
        display: flex;
        align-items: center;
        cursor: default;
        transition: background 0.15s ease-in-out;
        &:not(.active):hover {
            background: rgba(0, 0, 0, 0.04);
        }
        &.active {
            font-weight: bold;
            box-shadow: inset 0 -2px 0 var(--preview-primaryText);
        }
    }
    p {
        text-transform: uppercase;
        color: var(--preview-primaryText);
        font-size: 0.68rem;
        margin: 0;
        line-height: 1.2;
        letter-spacing: 1px;
        font-weight: inherit;
        white-space: nowrap;
    }
}

.button {
    position: relative;
    outline: none;
    background: var(--preview-primaryText);
    border: 0;
    border-radius: 4px;
    color: #fff;
    font-size: 0.7rem;
    text-transform: uppercase;
    padding: 0.5rem 1rem;
    box-shadow:
        0px 3px 1px -2px rgba(0, 0, 0, 0.2),
        0px 2px 2px 0px rgba(0, 0, 0, 0.14),
        0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(255, 255, 255, 0);
        z-index: 0;
        transition: background 0.15s ease-in-out;
    }
    &:hover {
        &:before {
            background: rgba(255, 255, 255, 0.3);
        }
    }
}

.switch {
    display: flex;
    align-items: center;
    background: var(--preview-primaryLight);
    padding: 0.5rem 0.5rem;
    margin-left: 1rem;
    border-radius: 4px;
    cursor: default;
    user-select: none;
    input {
        opacity: 0;
        width: 0;
        height: 0;
        &:checked + .switch__toggle {
            background: var(--preview-primaryText);
            &:after {
                left: 0.8rem;
            }
        }
    }
    &__toggle {
        position: relative;
        width: 1.7rem;
        height: 0.6rem;
        background: rgba(0, 0, 0, 0.15);
        margin-right: 0.4rem;
        border-radius: 2rem;
        &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            height: 0.8rem;
            width: 0.8rem;
            background: #fff;
            border-radius: 100%;
            border: 1px solid rgba(255, 255, 255, 0.5);
            box-shadow:
                0px 3px 1px -2px rgba(0, 0, 0, 0.2),
                0px 2px 2px 0px rgba(0, 0, 0, 0.14),
                0px 1px 5px 0px rgba(0, 0, 0, 0.12);
            transition: left 0.15s ease-in-out;
        }
    }
    p {
        font-weight: bold;
        color: var(--preview-primaryText);
        margin: 0;
        font-size: 0.8rem;
    }
}

.overline {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 0.7rem;
    color: var(--preview-primaryText);
    line-height: 1;
}

.heading {
    font-size: 1.6rem;
    color: var(--preview-primaryText);
    font-weight: 100;
    line-height: 1.6;
    margin-bottom: 0.4rem;
}

table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 4px;
    overflow: hidden;
    thead {
        border-bottom: 0.2rem solid var(--preview-primaryLight);
    }
    th {
        background: #f9f9f9;
        color: var(--preview-primaryText);
        font-size: 0.7rem;
        padding: 0.4rem 0.6rem;
        text-align: left;
        cursor: default;
        user-select: none;
        white-space: nowrap;
        &:first-of-type {
            border-right: thin solid rgba(0, 0, 0, 0.08);
        }
    }
    tbody {
        tr {
            background: #f9f9f9;
            &:not(&:last-of-type) {
                border-bottom: thin solid rgba(0, 0, 0, 0.12);
            }
            &:nth-of-type(odd) {
                background: #fff;
            }
            &:hover {
                background: var(--preview-primaryLight);
            }
        }
    }
    td {
        font-size: 0.7rem;
        padding: 0.4rem 0.6rem;
        color: rgba(0, 0, 0, 0.5);
        &:first-of-type {
            border-right: thin solid rgba(0, 0, 0, 0.08);
        }
    }
}
</style>
